mutation CreateInternalExpense($input: CreateInternalExpenseInput!) {
  createInternalExpense(input: $input) {
    id
  }
}
